import React, { useEffect, useState } from "react";
import { setTopNavbar } from "../../Reducers/actions/navbarActions";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllShipmentsByUser } from "../../Reducers/actions/ordersActions";
import ShipmentCard from "../../components/ShipmentCard/ShipmentCard";
import "./Shipments.scss";
import Icon from "../../components/Icon/Icon";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import CreationSkeleton from "../../components/CreationCard/CreationSkeleton";

const tabs = [
    { title: "All", orderStatus: undefined },
    { title: "Pending", orderStatus: "pending" },
    { title: "Shipped", orderStatus: "shipped" },
    { title: "Completed", orderStatus: "completed" },
];

const Shipments = () => {
    const LIMIT = 10;
    const [activeTab, setActiveTab] = useState(tabs[0]);
    const dispatch = useDispatch();

    const { shipments, loading } = useSelector((state) => state.orders);

    const fetchData = (offset, limit) => {
        dispatch(fetchAllShipmentsByUser(offset, limit, { order_status: activeTab.orderStatus }));
    };

    useEffect(() => {
        dispatch(
            setTopNavbar({
                title: "My purchases",
                back: true,
            })
        );
        dispatch(
            fetchAllShipmentsByUser(0, LIMIT, { order_status: activeTab.orderStatus })
        );
        resetPage();
    }, [activeTab.orderStatus]);

    const { resetPage } = useInfiniteScroll(fetchData, LIMIT, shipments?.totalCount || 0);

    return (
        <div className="shipments-container">
            <div className="tabs mb-16">
                {tabs.map((tab) => (
                    <button
                        key={tab.title}
                        className={`tab ${tab.title.toLowerCase()} ${activeTab.title === tab.title ? " active" : ""
                            }`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>
            {loading && !shipments?.data?.length ? (
              [1,2,3,4].map((item)=><CreationSkeleton key={item}/>)  
            ) : shipments?.totalCount ? (
                shipments?.data?.map((order) => (
                    <ShipmentCard key={order.order_id} order={order} 
                    thumbnail={order.creations.thumbnail_url} 
                    title={order?.creations?.title} 
                    userName={order?.creator?.userName }
                    creator={order?.creator}
                    profilePic={order?.creator?.profilePicture}
                    category={order?.creations?.category}
                    tags={order?.creations?.tags}
                    order_status={order?.order_status}
                    created_at={order?.created_at}
                    track={true} 
                    //added those props to reuse the components 
                    />
                ))
            ) : (
                <div className="d-flex f-column aic jcc no-messages px-16 mt-40 pt-40">
                    <Icon alias={"unboxing"} color={"#FF3232"} width={200} height={200} />
                    <p className="fs-sm2 fg-crea fw-medium-bold mt-40 mb-16">
                        No shipments for now
                    </p>
                    <p className="fg-hyk-grey">
                        Once someone buys a piece of work, their order will show up here.
                        Keep creating!
                    </p>
                </div>
            )}
        </div>
    );
};

export default Shipments;
